import React, { useEffect, useState, useMemo } from "react";
import { useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";

import Stack from "components/common/Stack";
import Box from "components/common/Box";
import { config } from "config/index";
import { thirdpartyApis } from "stores/thirdparty/thirdpartyApis";
import JarvisSubscriptionPlans from "components/JarvisSubscriptionPlans";
import { jarvisPrimeOnboardingActions } from "stores/jarvisPrime/jarvisPrimeOnboarding/jarvisPrimeOnboardingActions";

const PrimeInfoContainer = () => {
  const dispatch = useDispatch();

  const [subscriptionPlans, setSubscriptionPlans] = useState([]);
  const [selectedFrequency, setSelectedFrequency] = useState(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  useEffect(() => {
    dispatch(jarvisPrimeOnboardingActions.getOnboardingData());
    fetchSubscriptionPlans();
  }, [dispatch]);

  const fetchSubscriptionPlans = async () => {
    try {
      const res = await thirdpartyApis.getSubscriptionPlans({
        productCode: config.productCodes.PRIME,
      });
      setSubscriptionPlans(res || []);
    } catch (error) {
      console.error("Error fetching subscription plans:", error);
    }
  };

  const subscriptionFrequencies = useMemo(() => {
    const planFrequency = [];
    subscriptionPlans.forEach((plan) => {
      if (!planFrequency.includes(plan.planFrequency)) {
        planFrequency.push(plan.planFrequency);
      }
    });
    return planFrequency;
  }, [subscriptionPlans]);

  useEffect(() => {
    if (subscriptionFrequencies.length && !selectedFrequency) {
      // setSelectedFrequency(subscriptionFrequencies[0]);
      setSelectedFrequency("ALL");
    }
  }, [subscriptionFrequencies, selectedFrequency]);

  const filteredPlans = useMemo(() => {
    if (!selectedFrequency || selectedFrequency === "ALL") {
    return subscriptionPlans;
     }
    return subscriptionPlans.filter(
      (plan) => plan.planFrequency === selectedFrequency
    );
  }, [subscriptionPlans, selectedFrequency]);

  const handleFrequencyChange = ({ selectedFrequency }) => {
    setSelectedFrequency(selectedFrequency);
  };

  return (
    <Stack mt={2}>
      <Box mt={3}>
        <Stack>
          <JarvisSubscriptionPlans
            subscriptionPlans={filteredPlans}
            subscriptionFrequencies={subscriptionFrequencies}
            onFrequencyChange={handleFrequencyChange}
            selectedFrequency={selectedFrequency}
            currentInvestmentAmount={0}
            productTitle={"Jarvis Prime Pricing"}
            confirmDialog={{
              open: confirmDialogOpen,
              onConfirm: () => console.log("Confirmed"),
              onCancel: () => setConfirmDialogOpen(false),
              title: "Confirm Plan",
              content: "Are you sure you want to select this plan?",
            }}
            diasbleCircle
            forInfo
          />
        </Stack>
      </Box>
    </Stack>
  );
};

export default withRouter(PrimeInfoContainer);
